export function isValidJSON(value) {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
}

export function formatJSON(value) {
  if (typeof value === 'object') {
    // if it's an javascript object, then JSON.stringify(...) will do a great job of formatting
    return stringify(value);
  }
  // format JSON by hand
  // NOTE: we do this ourselves as opposed to using stringify because sometimes the cell might be TRIMMED, so JSON.parse(...) will fail
  const TAB = '\t';
  let result = '';
  let indent = 0;
  let inString = null; // ' or "
  for (let i = 0; i < value.length; i++) {
    const c = value[i];
    switch (c) {
      case '\\':
        result += c;
        if (i + 1 < value.length) {
          // next character is escaped
          result += value[i + 1];
          i++;
        }
        break;
      case '"':
      case "'":
        result += c;
        if (!inString) {
          inString = c;
        } else if (c === inString) {
          // end of string
          inString = null;
        }
        break;
      case '[':
      case '{':
        if (inString) {
          result += c;
          break;
        }
        indent++;
        result += `${c}\n${''.padEnd(indent, TAB)}`;
        break;
      case ']':
      case '}':
        if (inString) {
          result += c;
          break;
        }
        indent--;
        result += `\n${''.padEnd(indent, TAB)}${c}`;
        break;
      case ',':
        if (inString) {
          result += c;
          break;
        }
        result += `${c}\n${''.padEnd(indent, TAB)}`;
        if (i + 1 < value.length && value[i + 1] === ' ') {
          // skip unnecessary space
          i++;
        }
        break;
      default:
        result += c;
    }
  }
  return result;
}

export function stringify(value) {
  return JSON.stringify(value, null, '\t');
}
